/**
 * Static placeholder leaderboard rows used by `?mock=1` so the lobby renders
 * with content for visual previews/screenshots without a live game session.
 * Built via a single-object factory to keep the param count small.
 */

import type { LbRow } from '@sg/shared';

interface MockSpec { rank: number; id: number; name: string; pts: number; gp: number; gw: number }

function row(s: MockSpec): LbRow {
  return {
    rank: s.rank,
    player_id: s.id,
    display_name: s.name,
    avatar_seed: s.name,
    total_points: s.pts,
    games_played: s.gp,
    games_won: s.gw,
  };
}

export const MOCK_ROWS: LbRow[] = [
  row({ rank: 1, id: 1, name: 'AlphaWolf', pts: 1240, gp: 12, gw: 4 }),
  row({ rank: 2, id: 2, name: 'BetaTester', pts: 980, gp: 9, gw: 1 }),
  row({ rank: 3, id: 3, name: 'GammaRay', pts: 720, gp: 7, gw: 0 }),
];
